import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconAvailabilityClock: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        d="M18.3327 9.99984C18.3327 14.6032 14.6018 18.3332 9.99935 18.3332C5.39685 18.3332 1.66602 14.6032 1.66602 9.99984C1.66602 5.39817 5.39685 1.6665 9.99935 1.6665C14.6018 1.6665 18.3327 5.39817 18.3327 9.99984Z"
        fill="#E4E4E4"
      />
      <path
        d="M12.9779 13.1785C12.8687 13.1785 12.7587 13.1502 12.6579 13.091L9.3862 11.1393C9.19786 11.026 9.08203 10.8218 9.08203 10.6018V6.396C9.08203 6.051 9.36203 5.771 9.70703 5.771C10.052 5.771 10.332 6.051 10.332 6.396V10.2468L13.2987 12.016C13.5945 12.1935 13.692 12.5768 13.5154 12.8735C13.3979 13.0693 13.1904 13.1785 12.9779 13.1785Z"
        fill="#262626"
      />
    </Icon>
  );
};

export default IconAvailabilityClock;
